import React from 'react'
import * as moment from 'moment'
import FormCard from './FormCard';

export default function PeriodicFormCard(props) {


    const cardHeader = (name) =>

        <div className="card-header form-card-header" style={{ fontWeight: "700px" }}>
            <div>{name}</div>
            <div><input type="button" className="form-card-add-button" value="Add" onClick={() => props.showAddModal(name)} /></div>
        </div>

    const tableHeader =
        <tr>
            <th></th>
            <th>Period</th>
            <th>Status</th>
            <th>Created On</th>
            <th>Last Updated On</th>
            <th>Last Updated By</th>
            <th>Completed On</th>
        </tr>

    const tableBody = (data) =>
        <tr>
            <td><div><input type="button" className="form-card-edit-button" value="Edit" /></div></td>
            <td>{data.periodicityText}</td>
            <td>{data.status}</td>
            <td>{data.startedDate && moment(data.startedDate + "Z").format('MM/DD/YYYY')}</td>
            <td>{data.lastUpdatedDate && moment(data.lastUpdatedDate + "Z").format('MM/DD/YYYY')}</td>
            <td>{data.lastUpdatedBy}</td>
            <td>{data.completedDate && moment(data.completedDate + "Z").format('MM/DD/YYYY')}</td>
        </tr>


    return <FormCard cardHeader={cardHeader} tableHeader={tableHeader} tableBody={tableBody} {...props} ></FormCard>
}
